<template>
  <div v-if="hasMetadata">
    <ValidationObserver :ref="item.documentType+item.fileId">
      <v-row
          v-for="(meta, index) in item.metadata"
          :key="index"
          class="subheading font-weight-bold text-left">
        <v-col>
          <validatable-text-input
              v-if="meta.dataType === 'string'"
              :key="item.fileId+meta.propertyName"
              v-model="item.data[meta.propertyName]"
              v-test="{ id: item.documentType,
                        input: meta.propertyName }"
              :prepend-icon="getIcon(meta.propertyName)"
              :rules="{ required: meta.required && fileExist }"
              :readonly="readonly"
              :label="meta.description" />
          <validatable-date-picker
              v-if="meta.dataType === 'dateTime'"
              :key="item.fileId+meta.propertyName"
              v-model="item.data[meta.propertyName]"
              v-test="{
                id: item.documentType,
                date: meta.propertyName }"
              :rules="{ required: meta.required && fileExist }"
              :readonly="readonly"
              :label="meta.description" />
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import { mapActions } from 'vuex'
  import { IDENTITY_FILES } from '@/constants/store.js'

  export default {
    components: {
      ValidatableTextInput,
      ValidatableDatePicker
    },
    props: {
      document: {
        type: Object,
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      // если документ добавлен, то делаем проверку метаданных обязательной
      fileExist: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        item: {
          documentType: null,
          metadata: [],
          data: {}
        }
      }
    },
    computed: {
      hasMetadata () {
        return this.item.metadata?.length > 0
      }
    },
    watch: {
      document: {
        immediate: true,
        handler (newValue) {
          this.mapFields(newValue)
          this.createDynamicProperties(newValue)
        }
      }
    },
    methods: {
      ...mapActions(IDENTITY_FILES.NAMESPACE, {
        editRequestFileMetadataAction: IDENTITY_FILES.ACTIONS.EDIT_REQUEST_FILE_METADATA
      }),
      mapFields: function (value) {
        this.item.documentType = value.documentType
        if (!this.item.metadata || this.item.metadata.length === 0) {
          this.item.metadata = value.metadata || []
        }
      },
      createDynamicProperties: function (value) {
        const vm = this
        if (value.metadata && value.metadata.length > 0) {
          value.metadata.forEach(meta => {
            if (!vm.item.data[meta.propertyName] && !!value.data) {
              vm.item.data[meta.propertyName] = value.data[meta.propertyName] || null
            }
          })
        }
        vm.$forceUpdate()
      },
      getIcon: function (propertyName) {
        switch (propertyName) {
        case 'contactPerson':
          return 'person'
        case 'number':
          return 'mdi-bookmark-outline'
        default:
          return null
        }
      },
      validate: async function () {
        await this.$refs[this.item.documentType + this.item.fileId].validate()
      },
      syncronizeFieldsData: async function () {
        if (this.fileExist) {
          await this.editRequestFileMetadataAction({
            ...this.document,
            ...this.item
          })
        }
      }
    }
  }
</script>
